import Seo from "../components/common/Seo";
import PageHeader from "../components/common/PageHeader";
import { Reveal } from "../components/common/Reveal";
import FinalCTA from "../components/sections/FinalCTA";
import { processSteps } from "../lib/content";

export default function Process() {
  return (
    <>
      <Seo
        title="Process — Kratos Venture Group"
        description="Our operating model: discovery, workflow mapping, opportunity assessment, architecture, agent skill design, integration, configuration, testing, training, deployment, optimization, and long-term support."
        path="/process"
      />
      <PageHeader
        eyebrow="Process"
        title="A deliberate operating model, end to end."
        intro="Every engagement follows a clear path — from understanding how your business works to a system that keeps improving after launch."
      />

      <section className="relative py-16 md:py-24" data-testid="process-timeline">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="relative pl-10 md:pl-14">
            <div className="absolute left-[7px] md:left-[11px] top-2 bottom-2 w-px bg-kv-steel/25" aria-hidden />
            {processSteps.map((step, i) => (
              <Reveal key={step.title} delay={(i % 4) * 0.05}>
                <div className="relative pb-12 last:pb-0" data-testid={`process-step-${i + 1}`}>
                  <span className="absolute -left-[34px] md:-left-[46px] top-1.5 h-3.5 w-3.5 rounded-full bg-kv-royal kv-node ring-4 ring-kv-bg" />
                  <div className="flex items-baseline gap-4">
                    <h2 className="font-display text-xl md:text-2xl font-medium tracking-tight text-kv-off">{step.title}</h2>
                  </div>
                  <p className="mt-3 font-body text-sm md:text-base text-kv-grey leading-relaxed max-w-xl">{step.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </>
  );
}
